/**
 * Builds a full image URL from a stored path or key.
 *
 * The backend always returns a full URL for S3 files, so in most cases
 * this function just returns the value as-is. The legacy path handling
 * exists for any older records that were saved as relative disk paths
 * before the S3 migration.
 *
 * @param {string} baseUrl   - The backend base URL (REACT_APP_BACKEND_URL)
 * @param {string} imagePath - Full URL, S3 key, or legacy relative path
 * @returns {string|null}
 */
export function buildImageUrl(baseUrl, imagePath) {
    if (!imagePath) return null;

    // Already a full URL (S3 or any absolute URL) — use as-is
    if (imagePath.startsWith("http://") || imagePath.startsWith("https://")) {
        return imagePath;
    }

    // Legacy relative disk path — prepend the backend URL
    const base = baseUrl.endsWith("/") ? baseUrl.slice(0, -1) : baseUrl;
    const path = imagePath.startsWith("/") ? imagePath.slice(1) : imagePath;
    return `${base}/${path}`;
}
